import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import "./App.css";
import ProductDisplay from "./components/ProductDisplay";
import CartPage from "./carts/CartPage";
import ProfilePage from "./profile/components/ProfilePage";
import SearchPage from "./components/SearchPage";
import AboutUs from "./components/AboutUs";
import ContactPage from "./Contact";
import ElegantBackground from "./components/ElegantBackground";
import CategoryPage from "./components/CategoriesPage";
import LoginPage from "./auth/LoginPage";
import SignUpPage from "./auth/SignUpPage";
import WishlistPage from "./components/Wishlist";

function App() {
  const [count, setCount] = useState(0);

  return (
    <BrowserRouter>
      <ElegantBackground />
      <Routes>
        <Route index path="/" element={<LandingPage />} />
        <Route index path="/home" element={<LandingPage />} />
        <Route index path="/product-details" element={<ProductDisplay />} />
        <Route index path="/cart" element={<CartPage />} />
        <Route index path="/wishlist" element={<WishlistPage />} />
        <Route index path="/profile" element={<ProfilePage />} />
        <Route index path="/search" element={<SearchPage />} />
        <Route index path="/aboutus" element={<AboutUs />} />
        <Route index path="/contact" element={<ContactPage />} />
        <Route index path="/login" element={<LoginPage />} />
        <Route index path="/register" element={<SignUpPage />} />
        <Route index path="/category/:category" element={<CategoryPage />} />
        <Route path="/category/:category/:subcategory" element={<CategoryPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
